import { Redirect, Route, Switch } from 'react-router-dom';
import OAuthCallback from '../components/routing/OAuthCallback';
import { PrivateRoute } from '../components/routing/PrivateRoute';
import { getAuth } from '../hooks/useAuth';
import { getHomeRoute } from '../hooks/useHomeRedirect';

// ============================================
// COMPONENTES PÚBLICOS
// ============================================
import LoadingTransition from '../components/routing/LoadingTransition';
import AccessDenied from '../pages/AccessDenied/AccessDenied';
// import Login from '../pages/Login';
import Login from '../pages/LoginGoogle';
import NotFound from '../pages/NotFound';

// ============================================
// FEATURES - Eventos
// ============================================
// import EventsPage from '../features/events/pages/EventsPage';
import EventsPage from '../features/events/pages/InglesParanaKidsPage';
// import FalaProfessorPage from '../features/events/pages/FalaProfessorPage';
import { QuestionnaireViewerPage } from '../features/questionnaireViewer/pages/QuestionnaireViewerPage';
import { SearchPage } from '../features/search/pages/SearchPage';
import EventoPage from '../pages/Eventos';

// ============================================
// PAGES - Gerais
// ============================================

// Componente para proteger rota de login
function LoginRoute() {
  const { isLoggedIn } = getAuth();
  const hasOAuthToken = window.location.hash.includes('access_token');
  const isRedirectingToError =
    sessionStorage.getItem('auth_error_redirect') === 'true';

  if (isLoggedIn) {
    const homeRoute = getHomeRoute();
    return <Redirect to={homeRoute} />;
  }

  if (isRedirectingToError && !hasOAuthToken) {
    sessionStorage.removeItem('auth_error_redirect');
    return <Redirect to="/access-denied" />;
  }

  if (hasOAuthToken) {
    return <OAuthCallback />;
  }

  return <Login />;
}

export default function AllRoutes() {
  const userProfiles = [1, 2]; // Admin e UserEventSystem

  return (
    <Switch>
      {/* ==================== ROTAS PÚBLICAS ==================== */}
      <Route exact path="/" component={LoginRoute} />
      <Route exact path="/login" component={LoginRoute} />
      {/* <Route exact path="/solicitar-acesso" component={VerificarAcessoPage} />
      <Route
        exact
        path="/solicitar-acesso/formulario"
        component={SolicitarAcessoFormPage}
      /> */}

      {/* ==================== ROTA DE LOADING ==================== */}
      <Route exact path="/loading-login" component={LoadingTransition} />
      <Route exact path="/access-denied" component={AccessDenied} />
      <PrivateRoute
        path="/loading"
        component={LoadingTransition}
        allowedProfiles={userProfiles}
        exact
      />

      {/* ==================== ROTAS DE USUÁRIO ==================== */}

      {/* Home */}
      <PrivateRoute
        path="/home-user"
        // component={HomeUser}
        component={EventsPage}
        allowedProfiles={userProfiles}
        exact
      />

      {/* Consultar eventos disponíveis */}
      {/* <PrivateRoute
        path="/consulta-evento"
        component={EventsPage}
        allowedProfiles={userProfiles}
        exact
      /> */}

      <PrivateRoute
        path="/visualizar-eventos"
        component={EventsPage}
        allowedProfiles={userProfiles}
        exact
      />

      <PrivateRoute
        path="/historico"
        component={SearchPage}
        allowedProfiles={userProfiles}
        exact
      />

      <PrivateRoute
        path="/evento/evtid=:event/case=:useCase"
        component={EventoPage}
        allowedProfiles={userProfiles}
        exact
      />

      {/* <PrivateRoute
        path="/evento/:event/:useCase"
        component={EventoPage}
        allowedProfiles={userProfiles}
        exact
      /> */}

      <PrivateRoute
        path="/viewer/:useCaseId"
        component={QuestionnaireViewerPage}
        allowedProfiles={userProfiles}
        exact
      />
      <Route exact path="*" component={NotFound} />
    </Switch>
  );
}
